"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SearchResultsGenerator = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _lab = require("@material-ui/lab");
var _PaginatedPanel = _interopRequireDefault(require("./components/PaginatedPanel"));
var _config = require("./config");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
/**
 * This component provides a TabContext wrapper for the search results page
 *
 * @param {object} uiConfig - configuration object for the search results page
 * @return {object} { SearchResults }
 */
var SearchResultsGenerator = function SearchResultsGenerator() {
  var uiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.DEFAULT_CONFIG_SEARCHRESULTS;
  var config = uiConfig.config,
    classes = uiConfig.classes,
    functions = uiConfig.functions,
    uiTabs = uiConfig.tabs;
  var tabChange = functions && typeof functions.onTabChange === 'function' ? functions.onTabChange : _config.DEFAULT_CONFIG_SEARCHRESULTS.functions.onTabChange;
  var cardMap = config && config.resultCardMap ? config.resultCardMap : {};
  var pageSize = config && typeof config.pageSize === 'number' ? config.pageSize : _config.DEFAULT_CONFIG_SEARCHRESULTS.config.pageSize;
  var tabs = uiTabs && uiTabs instanceof Array ? uiTabs : [];
  var activeTab = config && typeof config.defaultTab === 'string' ? config.defaultTab : uiTabs[0].value;
  var getTabData = functions && typeof functions.getTabData === 'function' ? functions.getTabData : _config.DEFAULT_CONFIG_SEARCHRESULTS.functions.getTabData;
  return {
    SearchResults: function SearchResults(props) {
      var searchText = props.searchText;
      var _ref = (0, _react.useState)(activeTab),
        _ref2 = _slicedToArray(_ref, 2),
        tabValue = _ref2[0],
        setTabValue = _ref2[1];
      var onChangeWrapper = function onChangeWrapper(event, newTab) {
        setTabValue(newTab);
        tabChange(event, newTab);
      };
      (0, _react.useEffect)(function () {
        setTabValue(activeTab);
      }, [activeTab, searchText]);
      return /*#__PURE__*/_react.default.createElement(_lab.TabContext, {
        value: tabValue
      }, /*#__PURE__*/_react.default.createElement(_core.Box, {
        sx: {
          borderBottom: '1px solid #828282'
        }
      }, /*#__PURE__*/_react.default.createElement(_lab.TabList, {
        onChange: onChangeWrapper,
        "aria-label": "tabs",
        classes: {
          root: classes.tabContainter,
          indicator: classes.indicator
        }
      }, tabs.map(function (prop, idx) {
        return /*#__PURE__*/_react.default.createElement(_core.Tab, {
          key: "result_tab_".concat(idx),
          classes: prop.classes,
          label: /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
            id: "global_search_tab_label_".concat(idx)
          }, typeof prop.name === 'function' ? prop.name() : prop.name), ' ', /*#__PURE__*/_react.default.createElement("span", {
            id: "global_search_tab_count_".concat(idx)
          }, prop.count)),
          value: prop.value
        });
      }))), tabs.map(function (prop, idx) {
        return /*#__PURE__*/_react.default.createElement(_lab.TabPanel, {
          value: prop.value,
          key: "result_panel_".concat(idx)
        }, /*#__PURE__*/_react.default.createElement(_PaginatedPanel.default, {
          classes: prop.classes,
          searchText: searchText,
          count: prop.count,
          getTabData: getTabData,
          field: prop.field,
          pageSize: pageSize,
          resultCardMap: cardMap
        }));
      }));
    }
  };
};
exports.SearchResultsGenerator = SearchResultsGenerator;
var _default = SearchResultsGenerator;
exports.default = _default;